(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.js');
"use strict";

const {
  clx
} = svs.components.lbUtils;
const {
  WagerSkeletonDrawCard,
  WagerSkeletonCoupon,
  WagerSkeletonSideNav,
  WagerSkeletonResultCard,
  WagerSkeletonWinGroups,
  WagerSkeletonReceipt,
  WagerSkeletonButtons
} = svs.components.tipsen.modularBase;
const WagerSkeleton = _ref => {
  let {
    children,
    className
  } = _ref;
  return React.createElement("div", {
    className: clx('pg_my_bets_wager_fallback', className)
  }, React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid"
  }, children));
};
WagerSkeleton.DrawCard = WagerSkeletonDrawCard;
WagerSkeleton.Coupon = WagerSkeletonCoupon;
WagerSkeleton.SideNav = WagerSkeletonSideNav;
WagerSkeleton.ResultCard = WagerSkeletonResultCard;
WagerSkeleton.WinGroups = WagerSkeletonWinGroups;
WagerSkeleton.Receipt = WagerSkeletonReceipt;
WagerSkeleton.Buttons = WagerSkeletonButtons;
setGlobal('svs.components.tipsen.modularBase.WagerSkeleton', WagerSkeleton);

 })(window);